import '../../assets/css/validate.css'
import React, { useEffect, useState } from "react";
import "react-tabs/style/react-tabs.css";
import CountUp from "react-countup";
import users from '../../assets/img/users.png';
import workflow from '../../assets/img/workflow.png';
import Loader from '../../Loader'
import DashImg from '../../assets/img/dashimg.png'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Back from "../../Back";


import UserCard from "../Cards/UserCard";
import GroupCard from '../Cards/GroupCard';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import axios from 'axios';
import Tags from '../Tag/Tags';
import Workflow from '../Workflow/Workflows';


const SiteDashboard = () => {

  const { groupId } = useParams();
  const [search, setSearch] = useState("")
  const [activeKey, setActiveKey] = useState("groups")
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  var { apiBaseUrl } = configData.config;
  const { token } = userData;
  const [group, setGroup] = useState({
    name: null,
    users: 0,
    workflows: 0
  });

  useEffect(() => {

    const fetchTeamDetails = async () => {
      var { data } = await axios.get(`${apiBaseUrl}/api/uno/group/details/${groupId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log(data.data)

      setGroup(data.data);
    }

    fetchTeamDetails();

  }, [groupId, apiBaseUrl, token]);

  const changeTabKey = (key) => {
    setSearch("");
    setActiveKey(key);
  };

  return (
    <>
      <div className="loader">
        <Loader />
      </div>
      <div className="main-content">
        <Back />
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 tdata">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="card" style={{ padding: "15px 15px 0 15px" }}>
                      <div className="card-body">
                        <div className="displaydash">
                          <img src={DashImg} alt='' />
                        </div>
                        <div className="welcometext">
                          {/* <p>Welcome Back</p> */}
                          <h4>{group.name}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3">
                    <div className="card mini-stats-wid">
                      <div className="card-body">

                        <div className="flex-grow-1">
                          <p>Total User</p>
                          <h4>
                            <CountUp
                              start={0}
                              end={group.users}
                              duration={1}
                            />
                          </h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <img src={users} className="dashimg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3">
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="flex-grow-1">
                          <p>Total Workflows</p>
                          <h4>
                            <CountUp
                              start={0}
                              end={group.workflows}
                              duration={1}
                            />
                          </h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <img src={workflow} className="dashimg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">

                <div className="row">

                  <div className='col-12 filterhere'>
                    <Tabs activeKey={activeKey} onSelect={changeTabKey}>
                      <Tab eventKey="Tags" title="Tags">
                        <Tags groupId={groupId} searchIcon={false} search={search} />
                      </Tab>
                      <Tab eventKey="WorkFlow" title="WorkFlow">
                        <Workflow groupId={groupId} searchIcon={false} search={search} />
                      </Tab>
                      <Tab eventKey="groups" title="Groups">
                        <GroupCard search={search} />
                      </Tab>
                      <Tab eventKey="users" title="Users">
                        <UserCard search={search} />
                      </Tab>
                    </Tabs>

                    <form className="filterparent app-search app-search1 d-flex justify-content-end">
                      <div className="position-relative">
                        <span className="bx bx-search-alt"></span>
                        <input
                          type="text"
                          name="searchName"
                          className="form-control"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search...."
                          autocomplete="off"
                        />
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SiteDashboard;